<template>
  <transition name="fade">
    <div class="back-to-top" v-show="visible" @click="backToTop">
      <icon-back-to-top />
    </div>
  </transition>
</template>

<script>
import IconBackToTop from '@/assets/images/icons/back_to_top.svg';

export default {
  name: 'back-to-top',
  components: {
    IconBackToTop
  },
  data() {
    return {
      visible: false,
      visibleoffset: 600,
      visibleoffsetbottom: 0
    }
  },
  computed: {
    buttonID() {
      return this.id || 'checkbox-' + this._uid
    }
  },
  methods: {
    catchScroll () {
      const pastTopOffset = window.pageYOffset > this.visibleoffset
      const pastBottomOffset = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - this.visibleoffsetbottom
      this.visible = parseInt(this.visibleoffsetbottom) > 0 ? pastTopOffset && !pastBottomOffset : pastTopOffset
    },
    backToTop () {
      window.smoothscroll()
    }
  },
  mounted() {
    window.smoothscroll = () => {
      let currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll)
        window.scrollTo(0, Math.floor(currentScroll - (currentScroll / 5)))
      }
    }
    window.addEventListener('scroll', this.catchScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.catchScroll)
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active, 
.fade-leave-active {
  transition: opacity 300ms;
}
.fade-enter, 
.fade-leave-to {
  opacity: 0;
}
.back-to-top {
  cursor: pointer;
  position: fixed;
  bottom: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
}
</style>
